import React, { useContext } from "react";
import {
  Button,
  TextField,
} from "@mui/material";
import {
  DatePicker,
  TimePicker
} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from "dayjs";
import { statusColor } from "../../../../utils/statusColor";
import { Col, Container, Row } from "react-bootstrap";
import Context from "../../../../context/Context";
import language from "../../../../nls/language.json";
import "../styles/OutstandingPieces.css";
import { LoadSpinner } from "../../../../componentes/atoms/LoadSpinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const UpdateOutstandingPieces = ({ pendency, hangleStatusPendencias, handleUpdatePendency, loading }) => {
  const [buttonClicked, setButtonClicked] = React.useState(false);
  const {
    selectedCountry
  } = useContext(Context);

  return (
    <Container className=" p-3 m-0">
      {!loading ? (
        <div className="p-0">
        <Row>
          <Col className="p-0">
            <span className={`badge bg-${statusColor(pendency) === "error" ? "danger" : statusColor(pendency)} text-dark p-3`}>
              {pendency.pend_Status}
            </span>
          </Col>
        </Row>
        <Row className="py-3">
          <Col className="p-0 me-2">
            <TextField
              className="w-100"
              disabled
              label="Ordem"
              value={pendency.pend_Ordem}
            />
          </Col>
          <Col className="p-0 ms-2">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Data de Entrada"
                format="DD/MM/YYYY"
                value={dayjs(pendency.pend_DataEntrada)}
                disabled
              />
            </LocalizationProvider>
          </Col>
        </Row>
        <Row className="pb-3">
          <Col className="p-0 me-2">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Data de Previsão"
                format="DD/MM/YYYY"
                disabled={pendency.pend_Status !== "ABERTO"}
                value={dayjs(pendency.pend_DataPrevisao)}
                onChange={(e) => handleUpdatePendency({ name: "pend_DataPrevisao", value: new Date(e.$d) })}
              />
            </LocalizationProvider>
          </Col>
          <Col className="p-0 ms-2">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                label="Hora prevista"
                ampm={false}
                disabled={!pendency.pend_DataPrevisao || pendency.pend_Status !== "ABERTO"}
                defaultValue={dayjs('2023-11-10T00:00')}
                value={pendency.pend_DataPrevisao ? dayjs(pendency.pend_DataPrevisao) : dayjs('2023-11-10T00:00')}
                onChange={(e) => {
                  pendency.pend_DataPrevisao.setHours((e.$H - 3))
                  pendency.pend_DataPrevisao.setMinutes(e.$m)
                }}
              />
            </LocalizationProvider>
          </Col>
        </Row>
        <Row>
          <Col className="p-0">
            <TextField
              className="w-100"
              name="pend_Obs"
              multiline
              rows={4}
              maxRows={10}
              label="Descrição de Pendência"
              value={pendency.pend_Obs}
              onChange={({ target: { name, value } }) => handleUpdatePendency({ name, value })}
            />
          </Col>
        </Row>
        <Row className="pt-3 ">
          <Col className="p-0 d-flex justify-content-end">
            <Button
              variant="contained"
              onClick={async () => {
                setButtonClicked(true);
                await hangleStatusPendencias(pendency);
              }}
              disabled={!pendency.pend_DataPrevisao || buttonClicked}
            >
              <div className="p-2">
                {pendency.pend_Status === "ABERTO"
                  ? language[selectedCountry.name].Dashboard.pecasPendentes.modal.editar.btnSalvar
                  : language[selectedCountry.name].Dashboard.pecasPendentes.modal.editar.btnFinalizar
                }
              </div>
            </Button>
          </Col>
        </Row>
      </div>
      ) : (<FontAwesomeIcon icon={faSpinner} spin size="2x" />)}
      
    </Container >
  )
}

export default UpdateOutstandingPieces;
